import {Component, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import {RestaurantService} from "../../shared/services/restaurant/restaurant.service";
import {Restaurant} from "../../shared/model/restaurant";
import {ActivatedRoute, Router} from "@angular/router";
import {AuthService} from "../../shared/security/auth.service";
import {User} from "../../shared/model/user";
import {UserService} from "../../shared/services/user/user.service";
import {Modal} from "angular2-modal/plugins/bootstrap";
import {Overlay} from "angular2-modal";
import {TabsetComponent} from "ngx-bootstrap";

@Component({
  selector: 'restaurant-edit',
  templateUrl: 'restaurant-edit.component.html',
  styleUrls: ['restaurant-edit.component.css']
})
export class RestaurantEditComponent implements OnInit {
  restaurant: Restaurant;
  user: User;
  userId: string;

  // restaurantName : string;
  @ViewChild('staticTabs') staticTabs: TabsetComponent;

  constructor(private restaurantservice: RestaurantService,
              // private authservice: AuthService,
              // private userservice: UserService,
              private route: ActivatedRoute,
              private router: Router,
              public modal: Modal,
              overlay: Overlay,
              vcRef: ViewContainerRef
  ) {
    route.data
      .subscribe( ( data : {restaurant:Restaurant  }) =>
      {
        this.restaurant = data.restaurant;
      }

      )

  }

  ngOnInit() {

    this.route.queryParams.subscribe(params => {
      let tab = ["Restaurant", "Account"].indexOf(params['view'])
      // console.log("Params "+ params['view'])
      // console.log("Tab " + tab);
      this.staticTabs.tabs[tab > -1 ? tab : 0].active = true;
    });

  }




  cancel(form) {
    let navigateTo = '/restaurants/'+ form.restaurantId;
    this.router.navigate([navigateTo])
  }

  save(form) {




    const isPristine: boolean = form.form.pristine;

    const isValid = form.valid;

    // console.log(form)
    // console.log(isPristine + ' '+ isValid);

    if (isValid){



    this.restaurant.restaurant = form.value.restaurant;
    this.restaurant.address = form.value.address;
    this.restaurant.city = form.value.city;
    this.restaurant.state = form.value.state;
    this.restaurant.zip = form.value.zip;
    this.restaurant.isActive = form.value.isActive;
    this.restaurant.latitude = form.value.latitude;
    this.restaurant.longitude = form.value.longitude;
    this.restaurant.agreed = true;



      // DONE: get Coordinates



    const saveRestaurant$ = this.restaurantservice.saveRestaurant(this.restaurant);
    saveRestaurant$
      .subscribe(() => {
        this.router.navigate(['/restaurants'])
      }, err => this.messageIt('Error Editing a Restaurant ', err))


    } else {




      form.showErrors();

    }

    if(isPristine){
      this.router.navigate(['/restaurants'])
        .then();
    }



  }


  messageIt(titleP: string, messageP: string) {

    this.modal.alert()
      .size('lg')
      .showClose(true)
      .title(titleP)
      .body(messageP)
      .open();
  }

}




// WEBPACK FOOTER //
// ./src/app/restaurant/restaurant-edit/restaurant-edit.component.ts